import React from 'react'
import SendInvites from './SendInvites'

import PendingInvites from './PendingInvites'
import { Container } from '../styles'
import AcceptedInvites from './AcceptedInvites'
import EventListener from '../../../../../../utils/EventListener'

const Users = () => {
  const usersEventListener = new EventListener()

  return (
    <Container>
      <SendInvites eventListener={usersEventListener} />
      <PendingInvites eventListener={usersEventListener} />
      <AcceptedInvites eventListener={usersEventListener} />
    </Container>
  )
}

export default Users
